import UuidUtil from '../util/UuidUtil';

const CheckBox = ({ checked, span, onChecked }) => {
    const id = UuidUtil.generate();
    return (
        <div className='form-box form-box-checkbox'>
            <div className='input-box'>
                <div className='input-group'>
                    <input
                        type='checkbox'
                        checked={checked}
                        id={id}
                        className='form-control form-control-s'
                        onChange={(e) => onChecked(e.target.checked)}
                    />
                    <label htmlFor={id} className='check-label'>
                        <span>{span}</span>
                    </label>
                </div>
            </div>
        </div>
    );
};

export default CheckBox;
